export const storeGetters = {

  /** Get local config */
  config(state) {
    return state.clientConfig
  },

  env(state) {
    return (name) => state.envVars['VITE_' + name]
  },

  token(state) {
    return state.auth.token
  },

  user(state) {
    return state.auth.user
  },

  userId(state) {
    return state.auth?.user?.id ?? null;
  },

  apiPath(state) {
    return state.clientConfig.server.routes.api
  },

  isLoading: (state) => {
    return (key) => {
      return state.system.loading[key]
    }
  },

  currentLanguage(state) {
    return state.settings.language
  }

}